












import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      content: [
        {
          title: "Übungsdienst",
          author: "Philipp Meyer",
          text: "27.09., 18:00 – 19:00",
          date: "13:36 Uhr",
          status: "green"
        },
        {
          title: "PTÜR",
          author: "Schnittstelle",
          text: "Person hinter Tür eingeklemmt",
          date: "12:47 Uhr",
          status: "orange"
        },
        {
          title: "Straßensperrung",
          author: "Annette Oswald",
          text: "Wibbeltrather Weg ist ab sofort nicht mehr befahrbar.",
          date: "Gestern,  12:10",
          status: "blue"
        },
        {
          title: "Straßensperrung",
          author: "Annette Oswald",
          text: "Wibbeltrather Weg ist ab sofort nicht mehr befahrbar.",
          date: "Gestern,  12:10",
          status: "blue"
        },
        {
          title: "Straßensperrung",
          author: "Annette Oswald",
          text: "Wibbeltrather Weg ist ab sofort nicht mehr befahrbar.",
          date: "Gestern,  12:10",
          status: "blue"
        },
        {
          title: "Straßensperrung",
          author: "Annette Oswald",
          text: "Wibbeltrather Weg ist ab sofort nicht mehr befahrbar.",
          date: "Gestern,  12:10",
          status: "blue"
        }
      ]
    }
  }
})
